export const COMPETITIONTYPE_LEAGUE = 'league';
export const COMPETITIONTYPE_CUP = 'cup';

export class CompetitionStage {
    id: number;
    nr: number;
    stageType: string;
    numberOfClubs: number;

    constructor( id: number, nr: number, stageType: string, numberOfClubs: number ) {
        this.id = id;
        this.nr = nr;
        this.stageType = stageType;
        this.numberOfClubs = numberOfClubs;
    }
}